import { render, staticRenderFns } from "./My.vue?vue&type=template&id=4bbb13ec&scoped=true&"
import script from "./My.vue?vue&type=script&lang=js&"
export * from "./My.vue?vue&type=script&lang=js&"
import style0 from "./My.vue?vue&type=style&index=0&lang=less&"
import style1 from "./My.vue?vue&type=style&index=1&id=4bbb13ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbb13ec",
  null
  
)

export default component.exports